import React, { useState } from "react";
import "./login.css";
import { FaEye } from "react-icons/fa";
import { Navigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import IconRadaria from "../../assets/images/isotipos/RADARIA-ISOTIPO01-PNG.webp";
import { useDispatch, useSelector } from "react-redux";
import validateForm from "./validateLogin";
import { loginAuth } from "../../services/users/userService";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { login, setUser } from "../../redux/slice/authSlice";
const Login = () => {
  // const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  // console.log(isAuthenticated);
  const initialFormValues = {
    userName: "",
    password: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleChange = (e) => {
    // console.log("Evento detectado:", e);
    // console.log("e.target:", e.target);
    // console.log("name:", e.target.name);
    // console.log("value:", e.target.password);
    const { name, value } = e.target;
    delete errors[name];
    setFormValues({ ...formValues, [name]: value });
  };
  const sendData = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const validationErrors = validateForm(formValues);
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setLoading(false);
        return;
      }
      const userData = { ...formValues };
      const response = await loginAuth(userData);
      dispatch(login({ token: response?.token, isAuthenticated: true }));
      dispatch(
        setUser({
          _id: response?.user?.id,
          userName: response?.user?.userName,
          role: response?.user?.role,
        })
      );
      toast.success("Bienvenido a Radaria");
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`No se pudo procesar su solicitud. \n ${message}`);
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/dashboard/users" replace />;
  }
  return (
    <div className="wrapp-login">
      <Loading loading={loading} />
      <article className="d-flex flex-column wrap-form-login">
        <div>
          <img src={IconRadaria} alt="icon radaria" width={50} />
        </div>
        <form
          action=""
          onSubmit={(e) => sendData(e)}
          className="d-flex flex-column align-items-center"
        >
          {/* This input is comment when the exist API whit email  */}
          <div className="mb-3" style={{ width: "85%" }}>
            <label htmlFor="inputUserNameLogin" className="form-label">
              Usuario
            </label>
            <input
              type="text"
              name="userName"
              value={formValues.userName}
              onChange={handleChange}
              className={`form-control ${
                errors.userName && "is-invalid input-error"
              } text-light`}
              id="inputUserNameLogin"
              placeholder="Nombre de usuario"
              minLength={4}
            />
            {errors.userName && (
              <div id="invalidUserName" className="invalid-feedback">
                {errors.userName}
              </div>
            )}
          </div>

          <div className="mb-3 mt-3 " style={{ width: "85%" }}>
            <label htmlFor="inputPasswordLogin" className="form-label">
              Contraseña
            </label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formValues.password}
                onChange={handleChange}
                className={`form-control ${
                  errors.password && "is-invalid input-error"
                } text-light`}
                id="inputPasswordLogin"
                placeholder="Ingrese su contraseña"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
              />
              <button
                className="btn btn-outline-primary"
                type="button"
                id="button-addon2"
                onClick={() => setShowPassword(!showPassword)}
              >
                <FaEye />
              </button>
            </div>
            {errors.password && (
              <div id="invalid password" className="text-danger fs-6">
                {errors.password}
              </div>
            )}
          </div>
          <div className="col-auto mt-4">
            <button type="submit" className="btn btn-primary ">
              Ingresar
            </button>
          </div>
          {/* <div className="mt-3">
            <Link to="/reset-password">¿Olvidaste tu contraseña?</Link>
          </div> */}
        </form>
      </article>
    </div>
  );
};

export default Login;
